import React, { useState, useEffect } from 'react';
import { Container } from './styles';
import logoThrive from '../../assets/images/email_logo.png';

const Maintenance = () => {
    const [growthStage, setGrowthStage] = useState(0);

    useEffect(() => {
        const stages = [0, 1, 2, 3, 4, 5, 6, 7, 8, 8]; // Pausa breve no último
        let currentIndex = 0;

        const interval = setInterval(() => {
            currentIndex = (currentIndex + 1) % stages.length;
            setGrowthStage(stages[currentIndex]);
        }, 320); // Transições mais rápidas - 320ms por estágio

        return () => clearInterval(interval);
    }, []);

    // Estágio 0: Apenas solo/vaso
    const renderStage0 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
        </svg>
    );

    // Estágio 1: Solo + pequeno broto
    const renderStage1 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Broto inicial */}
            <path d="M40 85 Q40 80 40 75" 
                  stroke="#2D5016" 
                  strokeWidth="2.5" 
                  fill="none" 
                  strokeLinecap="round" />
            <path d="M40 75 Q35 70 38 68 Q40 67 42 68 Q45 70 40 75 Z" 
                  fill="#5ebc44" />
        </svg>
    );

    // Estágio 2: Caule crescendo
    const renderStage2 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Caule começando a crescer */}
            <path d="M40 85 Q40 75 40 68" 
                  stroke="#2D5016" 
                  strokeWidth="2.5" 
                  fill="none" 
                  strokeLinecap="round" />
            
            {/* Broto do topo */}
            <path d="M40 68 Q36 63 38 61 Q40 60 42 61 Q44 63 40 68 Z" 
                  fill="#5ebc44" />
        </svg>
    );

    // Estágio 3: Caule mais alto + primeira folha esquerda aparecendo
    const renderStage3 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Caule crescendo mais */}
            <path d="M40 85 Q40 70 40 58" 
                  stroke="#2D5016" 
                  strokeWidth="3" 
                  fill="none" 
                  strokeLinecap="round" />
            
            {/* Primeira folhinha esquerda */}
            <path d="M40 68 Q32 66 30 62 Q31 58 34 59 Q37 61 40 64 Z" 
                  fill="#4DAE49" 
                  opacity="0.7" />
            
            {/* Broto do topo */}
            <path d="M40 58 Q36 53 38 51 Q40 50 42 51 Q44 53 40 58 Z" 
                  fill="#5ebc44" />
        </svg>
    );

    // Estágio 4: Primeira folha direita aparece
    const renderStage4 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Caule */}
            <path d="M40 85 Q40 70 40 55" 
                  stroke="#2D5016" 
                  strokeWidth="3" 
                  fill="none" 
                  strokeLinecap="round" />
            
            {/* Folhas inferiores */}
            <path d="M40 68 Q30 65 27 60 Q28 55 32 57 Q37 60 40 64 Z" 
                  fill="#4DAE49" />
            <path d="M40 68 Q50 65 53 60 Q52 55 48 57 Q43 60 40 64 Z" 
                  fill="#50af47" />
            
            {/* Broto do topo */}
            <path d="M40 55 Q36 50 38 48 Q40 47 42 48 Q44 50 40 55 Z" 
                  fill="#5ebc44" />
        </svg>
    );

    // Estágio 5: Caule mais alto + folhas inferiores completas
    const renderStage5 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Caule mais alto */}
            <path d="M40 85 Q40 65 40 42" 
                  stroke="#2D5016" 
                  strokeWidth="3.5" 
                  fill="none" 
                  strokeLinecap="round" />
            
            {/* Folhas inferiores completas */}
            <path d="M40 67 Q23 63 16 48 Q15 38 21 35 Q27 33 33 38 Q38 43 40 52 Z" 
                  fill="#4DAE49" />
            <path d="M40 67 Q57 63 64 48 Q65 38 59 35 Q53 33 47 38 Q42 43 40 52 Z" 
                  fill="#50af47" />
            
            {/* Broto do topo */}
            <path d="M40 42 Q36 36 38 33 Q40 32 42 33 Q44 36 40 42 Z" 
                  fill="#5ebc44" />
        </svg>
    );

    // Estágio 6: Folhas médias pequenas aparecem
    const renderStage6 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Caule crescendo mais */}
            <path d="M40 85 Q40 65 40 50 Q40 38 40 28" 
                  stroke="#2D5016" 
                  strokeWidth="3.5" 
                  fill="none" 
                  strokeLinecap="round" />
            
            {/* Folhas inferiores completas */}
            <path d="M40 67 Q23 63 16 48 Q15 38 21 35 Q27 33 33 38 Q38 43 40 52 Z" 
                  fill="#4DAE49" />
            <path d="M40 67 Q57 63 64 48 Q65 38 59 35 Q53 33 47 38 Q42 43 40 52 Z" 
                  fill="#50af47" />
            
            {/* Folhas médias pequenas começando */}
            <path d="M40 48 Q32 46 30 41 Q31 37 34 38 Q37 40 40 43 Z" 
                  fill="#4DAE49" 
                  opacity="0.7" />
            <path d="M40 48 Q48 46 50 41 Q49 37 46 38 Q43 40 40 43 Z" 
                  fill="#50af47" 
                  opacity="0.7" />
            
            {/* Broto do topo */}
            <path d="M40 28 Q36 22 38 19 Q40 18 42 19 Q44 22 40 28 Z" 
                  fill="#5ebc44" />
        </svg>
    );

    // Estágio 7: Folhas médias crescem
    const renderStage7 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Caule crescendo para o topo */}
            <path d="M40 85 Q40 65 40 50 Q40 35 40 18" 
                  stroke="#2D5016" 
                  strokeWidth="3.5" 
                  fill="none" 
                  strokeLinecap="round" />
            
            {/* Folhas inferiores completas */}
            <path d="M40 67 Q23 63 16 48 Q15 38 21 35 Q27 33 33 38 Q38 43 40 52 Z" 
                  fill="#4DAE49" />
            <path d="M40 67 Q57 63 64 48 Q65 38 59 35 Q53 33 47 38 Q42 43 40 52 Z" 
                  fill="#50af47" />
            
            {/* Folhas médias crescendo */}
            <path d="M40 47 Q28 44 22 33 Q20 25 24 22 Q29 20 34 25 Q38 29 40 36 Z" 
                  fill="#4DAE49" />
            <path d="M40 47 Q52 44 58 33 Q60 25 56 22 Q51 20 46 25 Q42 29 40 36 Z" 
                  fill="#50af47" />
            
            {/* Folhas superiores pequenas começando */}
            <path d="M40 30 Q33 28 30 23 Q31 19 34 20 Q37 21 40 25 Z" 
                  fill="#4DAE49" 
                  opacity="0.7" />
            <path d="M40 30 Q47 28 50 23 Q49 19 46 20 Q43 21 40 25 Z" 
                  fill="#50af47" 
                  opacity="0.7" />
            
            {/* Broto do topo */}
            <path d="M40 18 Q36 12 38 9 Q40 8 42 9 Q44 12 40 18 Z" 
                  fill="#5ebc44" />
        </svg>
    );

    // Estágio 8: Planta completa com todas as folhas
    const renderStage8 = () => (
        <svg className="plant-icon" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="40" cy="92" rx="28" ry="6" fill="#8B7355" opacity="0.5" />
            <path d="M20 92 L25 85 L55 85 L60 92 Z" fill="#A0826D" opacity="0.6" />
            
            {/* Caule completo */}
            <path d="M40 85 Q40 70 40 50 Q40 30 40 15" 
                  stroke="#2D5016" 
                  strokeWidth="3.5" 
                  fill="none" 
                  strokeLinecap="round" />
            
            {/* Folhas inferiores */}
            <path className="leaf" 
                  d="M40 65 Q20 60 15 45 Q15 35 22 32 Q28 30 33 35 Q38 40 40 50 Z" 
                  fill="#4DAE49" />
            <path className="leaf-vein" 
                  d="M40 65 Q30 55 28 45" 
                  stroke="#387722" 
                  strokeWidth="1.5" 
                  fill="none" 
                  opacity="0.6" />
            <path className="leaf" 
                  d="M40 65 Q60 60 65 45 Q65 35 58 32 Q52 30 47 35 Q42 40 40 50 Z" 
                  fill="#50af47" />
            <path className="leaf-vein" 
                  d="M40 65 Q50 55 52 45" 
                  stroke="#387722" 
                  strokeWidth="1.5" 
                  fill="none" 
                  opacity="0.6" />
            
            {/* Folhas médias */}
            <path className="leaf" 
                  d="M40 45 Q25 42 18 30 Q16 22 21 18 Q27 15 32 20 Q37 25 40 33 Z" 
                  fill="#4DAE49" />
            <path className="leaf-vein" 
                  d="M40 45 Q32 38 30 28" 
                  stroke="#387722" 
                  strokeWidth="1.5" 
                  fill="none" 
                  opacity="0.6" />
            <path className="leaf" 
                  d="M40 45 Q55 42 62 30 Q64 22 59 18 Q53 15 48 20 Q43 25 40 33 Z" 
                  fill="#50af47" />
            <path className="leaf-vein" 
                  d="M40 45 Q48 38 50 28" 
                  stroke="#387722" 
                  strokeWidth="1.5" 
                  fill="none" 
                  opacity="0.6" />
            
            {/* Folhas superiores */}
            <path className="leaf" 
                  d="M40 28 Q30 26 24 18 Q22 12 26 9 Q31 7 35 11 Q38 15 40 20 Z" 
                  fill="#4DAE49" />
            <path className="leaf" 
                  d="M40 28 Q50 26 56 18 Q58 12 54 9 Q49 7 45 11 Q42 15 40 20 Z" 
                  fill="#50af47" />
            
            {/* Broto do topo */}
            <path className="leaf-top" 
                  d="M40 15 Q35 8 38 4 Q40 2 42 4 Q45 8 40 15 Z" 
                  fill="#5ebc44" />
            <ellipse cx="40" cy="8" rx="2.5" ry="3.5" fill="#5ebc44" />
        </svg>
    );

    const renderPlant = () => {
        switch (growthStage) {
            case 0: return renderStage0();
            case 1: return renderStage1();
            case 2: return renderStage2();
            case 3: return renderStage3();
            case 4: return renderStage4();
            case 5: return renderStage5();
            case 6: return renderStage6();
            case 7: return renderStage7();
            case 8: return renderStage8();
            default: return renderStage0();
        }
    };

    return (
        <Container>
            <div className="maintenance-card">
                <div className="logo-wrapper">
                    <img src={logoThrive} alt="Thrive" />
                </div>
                <div className="plant-wrapper">
                    {renderPlant()}
                </div>
                <h1>System Under Maintenance</h1>
                <p className="subtitle">
                We are performing a planned system freeze from January 29 to February 1, during which the system will be unavailable. This freeze is required to deploy Version V3 and update the technical packages.
                </p>
                <p className="message">
                    Thank you for your patience. We will be back online shortly after the maintenance is complete.
                </p>
                <div className="progress-bar">
                    <div className="progress-fill" />
                </div>
            </div>
        </Container>
    );
};

export default Maintenance;
